import React, { useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import Button from "@material-tailwind/react/Button";
import { Link } from "react-router-dom";
import ReactLeafletKml from "react-leaflet-kml";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/HashLoader";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
const km =
  '<?xml version="1.0" encoding="utf-8"?>\n' +
  '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
  "  <Document>\n" +
  "    <Placemark>\n" +
  "      <name>Portland</name>\n" +
  "      <Point>\n" +
  "        <coordinates>-122.681944,45.52,0</coordinates>\n" +
  "      </Point>\n" +
  "    </Placemark>\n" +
  "    <Placemark>\n" +
  "      <name>Rio de Janeiro</name>\n" +
  "      <Point>\n" +
  "        <coordinates>-83.196389,-22.908333,0</coordinates>\n" +
  "      </Point>\n" +
  "    </Placemark>\n" +
  "    <Placemark>\n" +
  "      <name>Istanbul</name>\n" +
  "      <Point>\n" +
  "        <coordinates>28.976018,41.01224,0</coordinates>\n" +
  "      </Point>\n" +
  "    </Placemark>\n" +
  "    <Placemark>\n" +
  "      <name>Reykjavik</name>\n" +
  "      <Point>\n" +
  "        <coordinates>-21.933333,64.133333,0</coordinates>\n" +
  "      </Point>\n" +
  "    </Placemark>\n" +
  "    <Placemark>\n" +
  "      <name>Simple Polygon</name>\n" +
  "      <Polygon>\n" +
  "        <outerBoundaryIs>\n" +
  "          <LinearRing>\n" +
  "            <coordinates>-22.681944,45.52,0\n" +
  "            -43.196389,-22.908333,0\n" +
  "            8.976018,41.01224,0\n" +
  "            -21.933333,64.133333,0\n" +
  "            -122.681944,45.52,0</coordinates>\n" +
  "          </LinearRing>\n" +
  "        </outerBoundaryIs>\n" +
  "      </Polygon>\n" +
  "    </Placemark>\n" +
  "  </Document>\n" +
  "</kml>\n";

export default function HeaderLocation(props) {
  let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
  });
  const [position, setPosition] = useState(props.positionGlobal1);
  const [kml, setKml] = React.useState(null);
  const [clicked, setclicked] = useState(false);
  const [keyMAP, setkeyMAP] = useState(1);
  const [tileSizeKm, settileSizeKm] = useState(0);
  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#ffffff");
  let pos =
    props.positionGlobal1.lat.toFixed(3) +
    "," +
    props.positionGlobal1.lng.toFixed(3);
  useEffect(async () => {
    tileIt();
    let pos =
      props.positionGlobal1.lat.toFixed(3) +
      "," +
      props.positionGlobal1.lng.toFixed(3);
  }, [position]);

  function MyComponent() {
    const map = useMap();
    console.log("map center:", map.getCenter());
    if (clicked) {
      map.flyTo(position, 14);
      setclicked(false);
    }
    return null;
  }

  function LocationMarker() {
    const markerRef = useRef(null);

    const eventHandlers = useMemo(
      () => ({
        dragend() {
          const marker = markerRef.current;
          if (marker != null) {
            setPosition(marker.getLatLng());
            props.handleCallback1(marker.getLatLng());
            // tileIt();
          }
        },
      }),
      []
    );
    return position === null ? null : (
      <Marker
        position={position}
        icon={DefaultIcon}
        draggable={true}
        eventHandlers={eventHandlers}
        ref={markerRef}
        iconSize={[35, 46]}
        iconAnchor={[17, 46]}
      >
        <Popup> </Popup>
        <Popup minWidth={90}>
          Your kml centre will be on {position.lat} {","} {position.lng}
        </Popup>
      </Marker>
    );
  }

  const positionget = async () => {
    await navigator.geolocation.getCurrentPosition(
      (position1) => {
        console.log(position1.coords);
        var mypos = { lat: 99.41781926152715, lng: 21.042068918181126 };
        mypos.lat = position1.coords.latitude;
        mypos.lng = position1.coords.longitude;
        setPosition(mypos);
        setclicked(true);
      },
      (err) => console.log(err)
    );
  };
  const CIRCUMFERENCE_OF_THE_EARTH = 40075; // km
  const TILES = 2 ** 14;
  const KM_TO_MILES = 0.62137;

  function toRadians(angle) {
    return angle * (Math.PI / 180);
  }

  function tileIt() {
    // Size = Circumference of Earth * cos(latitude) / 2^14
    let km =
      (CIRCUMFERENCE_OF_THE_EARTH * Math.cos(toRadians(position.lat))) / TILES;
    let miles = (km * KM_TO_MILES).toFixed(2);
    km = km.toFixed(2);
    settileSizeKm(km);
    console.log(km);
    console.log(miles);
  }

  const deg2rad = function (degrees) {
    const pi = Math.PI;
    return degrees * (pi / 180);
  };
  // function calcTile(co) {
  //   var x = Math.floor((((co.longitude + 180) / 360) * Math.pow(2, 14)));
  //   var y = Math.floor((((1 -
  //               Math.log(Math.tan(deg2rad(co.latitude)) +
  //                   1 / Math.cos(deg2rad(co.latitude))) /
  //               Math.pi) /
  //           2) *
  //       Math.pow(2, 14))
  // );
  //   console.log('ssss')
  //   console.log(x)
  //   return x.toString()+";"+y.toString();
  // }

  const calcTile = function (item) {
    const x = Math.floor(((item.lng + 180) / 360) * Math.pow(2, 14));
    const y = Math.floor(
        ((1 -
                Math.log(
                    Math.tan(deg2rad(item.lat)) + 1 / Math.cos(deg2rad(item.lat))
                ) /
                Math.PI) /
            2) *
        Math.pow(2, 14)
    );
    return "14;" + x.toString()+";"+y.toString()
  };
  const calcTileWithZ = function (item,zoom) {
    const x = Math.floor(((item.lng + 180) / 360) * Math.pow(2, zoom));
    const y = Math.floor(
        ((1 -
                Math.log(
                    Math.tan(deg2rad(item.lat)) + 1 / Math.cos(deg2rad(item.lat))
                ) /
                Math.PI) /
            2) *
        Math.pow(2, zoom)
    );
    return zoom.toString()+";" + x.toString()+";"+y.toString()
  };
  function loadKmlUnvisited() {
    loadKml("0");
  }

  function loadKmlVisited() {
    loadKml("1");
  }

  async function loadKml(visited) {
    setLoading(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    await fetch(
      `https://sh2kml4ridealltiles.herokuapp.com/Tile.kml?share_link=${props.shLink}&homeCoordinates=${pos}&visited=${visited}&astext=1`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        const parser = new DOMParser();
        const kml = parser.parseFromString(result, "text/xml");
        setKml(kml);
        setkeyMAP(Math.random());
        // console.log(result);
        setLoading(false);
      })
      .catch((error) => console.log("error", error));
  }

  function loadFakeKml() {
    const parser = new DOMParser();
    const kml = parser.parseFromString(km, "text/xml");
    setKml(kml);
    setkeyMAP(Math.random());
  }

  return (
    <div className="relative pt-16 pb-32 flex content-center items-center justify-center h-screen">
      <div className="bg-landing-background bg-cover bg-center absolute top-0 w-full h-full" />
      <div className="container max-w-8xl relative mx-auto">
        <ClipLoader color={color} loading={loading} css={override} size={150} />
        <MapContainer center={position} zoom={5} scrollWheelZoom={false}>
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <LocationMarker />
          <MyComponent />
          {/*<ReactLeafletKml key={keyMAP} kml={kml} />*/}
        </MapContainer>
        <p style={{ color: "white" }}>
          Your kml centre will be on {position.lat.toFixed(3)} {","}
          {position.lng.toFixed(3)} Squere size on cursor location is{" "}
          {tileSizeKm} [km], {(tileSizeKm * KM_TO_MILES).toFixed(3)}[miles]

          Square number on cursor location has number
          number {" "}
          {calcTile(position)}{" "}
          {calcTileWithZ(position,13)}{" "}
          {calcTileWithZ(position,12)}{" "}
          {calcTileWithZ(position,11)}{" "}


        </p>
        {/*<p>{props.shLink}</p>*/}
        <div className="items-center flex flex-wrap">
          <Link to="/">
            <Button color="lightBlue" ripple="light" className=" mr-2">
              Back to main Page
            </Button>
          </Link>
          <Button
            onClick={positionget}
            color="lightBlue"
            ripple="light"
            className=" mr-2"
          >
            Get Your Location
          </Button>
          {/*<Button*/}
          {/*  onClick={loadKmlUnvisited}*/}
          {/*  color="lightBlue"*/}
          {/*  ripple="light"*/}
          {/*  className=" mr-2"*/}
          {/*>*/}
          {/*  Show unvisited*/}
          {/*</Button>*/}
          {/*<Button*/}
          {/*  onClick={loadKmlVisited}*/}
          {/*  color="lightBlue"*/}
          {/*  ripple="light"*/}
          {/*  className=" mr-2"*/}
          {/*>*/}
          {/*  Show visited*/}
          {/*</Button>*/}

          {/*{km}*/}
        </div>
      </div>
    </div>
  );
}
